import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import './button.css';

export interface IButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  children: ReactNode;
  type?: 'btn' | 'link';
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'transparent';
  size?:
    | 'small'
    | 'medium'
    | 'larage'
    | 'small block'
    | 'medium block'
    | 'larage block'
    | 'block';
  variant?: 'normal' | 'circle' | 'outline' | 'outlined';
  disabled?: boolean;
  cy: string;
}

export const Button: React.FC<IButtonProps> = ({
  children,
  type = 'btn',
  color = 'default',
  variant = 'normal',
  size = 'medium',
  disabled = false,
  cy,
  ...props
}) => {
  return (
    <button
      {...props}
      data-cy={`Button${cy}`}
      className={
        props.className
          ? props.className
          : `${type} ${color} ${variant} ${size} `
      }
      disabled={disabled}
      type={type === 'btn' ? 'submit' : 'button'}
    >
      {children}
    </button>
  );
};
